/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

export enum UserRole {
  SuperAdmin = 'ROLE_SUPER_ADMIN',
  Admin = 'ROLE_ADMIN',
  User = 'ROLE_USER',
  Reader = 'ROLE_READER',
  Personnel = 'ROLE_PERSONNEL',
}
